<template>
    <div class="my-2 xl:my-4">
        <div v-if="isEnterprise" class="flex items-center justify-center">
            <AppEnterpriseSelect
                :is-disabled="false"
                :cycle="activeCycle"
                :range-value="creditPerMonthEnterprise"
                :is-yearly="activeCycle === 'yearly'"
                @emit-data="changePricePackage"
            />
            <span class="text-gray-400 text-title-sm font-bold ml-1"> Photos</span>
            <span class="text-body-lg text-gray-500">/mo</span>
        </div>
        <p v-else>
            <span class="text-gray-400 text-title-sm font-bold">{{ creditPerMonth }} Photos</span>
            <span class="text-body-lg text-gray-500">/mo</span>
        </p>
    </div>
</template>

<script setup lang="ts">
interface IProps {
    isEnterprise: boolean;
    creditPerMonth: number;
}

const props = defineProps<IProps>();

const creditPerMonthEnterprise = ref(props.creditPerMonth);
const { enterprisePricePackages, selectedPricePackage, activePricePackageIndex } = storeToRefs(usePricingStore());
const { activeCycle } = storeToRefs(usePricingStore());
const changePricePackage = (selectedPackageData: any, currencyIndex: number) => {
    activePricePackageIndex.value = currencyIndex;
    const [selectedPackage] = enterprisePricePackages.value?.filter((item) => {
        return item.credit === selectedPackageData.credit;
    });
    selectedPricePackage.value = selectedPackage;
    creditPerMonthEnterprise.value = selectedPackage.credit_per_month;
};
</script>
